module.exports = __webpack_public_path__ + "static/media/06.e9827047.jpg";